import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Willkommen zurück!");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Anmeldung fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-sand-100 flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="font-display text-3xl text-stone-900 block mb-12 hover:text-clay transition-colors" data-testid="login-home-link">
          ← Zur Webseite
        </Link>
        <div className="bg-white border border-sand-300 p-10 rounded-sm">
          <p className="text-xs uppercase tracking-[0.2em] text-sage font-bold mb-3">Admin Bereich</p>
          <h1 className="font-display text-4xl mb-2 text-stone-900">Anmelden</h1>
          <p className="text-stone-600 mb-8 text-sm">Bitte melden Sie sich mit Ihren Zugangsdaten an.</p>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-stone-900 mb-2 block">E-Mail</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email-input"
                className="border-sand-300 bg-sand-100"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-stone-900 mb-2 block">Passwort</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password-input"
                className="border-sand-300 bg-sand-100"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full bg-stone-900 hover:bg-clay text-sand-100 rounded-sm h-12 mt-4 transition-colors duration-300"
            >
              {loading ? "Anmelden…" : "Anmelden"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
